<template>
  <div>
    <v-container>
      <v-row v-if="!entry.answered && (entry.totalRetry == null || entry.totalRetry < 2)">
        <v-col>
          <v-btn outlined large block 
          color="fanhiveHoney"
          @click="goToQuestions(entry)"
          style="color: #ffffff !important;border: 1px solid #ffb300;"
          >Answer Questions</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="entry.answered || entry.totalRetry >= 2">
        <v-col>
          <v-icon
            left
            dark
            large
            color="green"
          >
            mdi-check-circle
          </v-icon>
          Questions answered
        </v-col>
      </v-row>
      <v-row v-if="!entry.voted" class="mt-0">
        <v-col>
          <v-btn outlined large block 
          color="fanhiveHoney"
          @click="goTo(entry, 'voting')"
          style="color: #ffffff !important;border: 1px solid #ffb300;"
          >Select Player of the Match</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="entry.voted" class="mt-0">
        <v-col>
          <v-icon
            left
            dark
            large
            color="green"
          >
            mdi-check-circle
          </v-icon>
          Selected player of the match
        </v-col>
      </v-row>
      <v-row v-if="!entry.rated" class="mt-0">
        <v-col>
          <v-btn outlined large block 
          color="fanhiveHoney"
          @click="goTo(entry, 'rating')"
          style="color: #ffffff !important;border: 1px solid #ffb300;"
          >Rate Players <sub class="small-text" style="text-transform: lowercase;padding-left:4px;">optional</sub></v-btn>
        </v-col>
      </v-row>
      <v-row v-if="entry.rated" class="mt-0">
        <v-col>
          <v-icon
            left
            dark
            large
            color="green"
          >
            mdi-check-circle
          </v-icon>
          Rated players
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-1" style="text-align: center;">
          <CountdownClock 
          :date="entry.competitionOpenDate" 
          title="Voting and Rating opens" 
          blockClass="countdown-digit-green"
          endText="Voting is open"
          :displayTime="entry.competitionOpenDate | moment('HH:mm')"></CountdownClock>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-1" style="text-align: center;">
          <CountdownClock 
          :date="entry.competitionEndDate" 
          title="Competition closes in" 
          blockClass="countdown-digit-red"
          endText="Voting is closed"
          :displayTime="entry.competitionEndDate | moment('HH:mm')"></CountdownClock>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="dialogNotOpenForVotingAndRating"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Not Open Yet</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="color:#ffffff;" class="honeyBold">
          <p>
            This competition is not yet open for voting and rating.
          </p>
          <p>
            Try again between <b>{{entry.competitionOpenDate | moment("HH:mm")}}</b> and  <b>{{entry.competitionEndDate | moment("HH:mm")}}</b> 
            on {{entry.competitionOpenDate | moment("dddd, MMMM DD, YYYY")}} 
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="fanhiveHoney"
            text
            @click="dialogNotOpenForVotingAndRating = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import CountdownClock from './CountdownClock.vue';

export default {
  data: () => ({
    dialogNotOpenForVotingAndRating: false
  }),
  name: 'EntryButtons',
  components: {
    CountdownClock
  },
  props: ['entry'],
  computed: {
    openForVotingAndRating () {
      return moment(this.entry.competitionOpenDate) <= moment()
    }
  },
  methods: {
    goToQuestions: function (entry) {
      this.$router.push({name: 'questions', query: { 
        entryId: entry.id,
        sportId: entry.sportId,
        totalQuestions: entry.totalQuestions,
        retry: 0
      }});
    },
    goTo: function (entry, page) {
      if(this.openForVotingAndRating) {
        this.$router.push({name: page, query: { 
          entryId: entry.id,
          matchId: entry.matchId
        }});
      } else {
        this.dialogNotOpenForVotingAndRating = true;
      }
    }
  }
}
</script>
